<style src="@/assets/styles/utils/tooltip.styl" lang="stylus"></style>
<template>
  <div :class="customClass">
    <div class="cb-cart" :class="{'cb-cart--multiple': isMultipleCart}">
        <cb-slide-n-fade :is-list="true" :timeOut="true" :reCalculateMargin = "true">
        <line-item :readonly="readonly" :singleCart='!isMultipleCart' :item='item' :singleItem='isSingleItem' :currencyCode='currency_code' v-for="item in order_cart_items" v-if="loaded(item)" v-bind:key="item.id"></line-item>
        </cb-slide-n-fade>
        <slot name="addons"></slot>
    </div>
    <div class="cb-cart cb-cart--multiple cb-cart--footer" v-if="isMultipleCart">
        <cb-slide-n-fade :is-list="true" :timeOut="true" :reCalculateMargin = "true">
        <template v-if="is_discount_present">
          <div class="cb-item--extras cb-transition__fade" v-for="(coupon, index) in coupons" v-bind:key="index">
            <div class="cb-item__name">{{coupon.description}}
              <div class="tooltip" v-if="isManualDiscount(coupon)">
                <i class="icon-info-circle cb-notebar__muted info"></i>
                <span class="tooltiptext" v-cb-html="getDiscountTooltipMessage"></span>
              </div>
              <div @click="removeDiscount(coupon.entity_id)" class="cb-item__action cb-extras__action" v-cb-link="'color'" v-if="coupon_enabled && coupon.entity_id && !readonly && !isManualDiscount(coupon)">{{ct('cart.remove')}}</div>
            </div>
            <div class="cb-item__deduction">{{ coupon.amount | cbCurrency(currency_code, true) }}</div>
          </div>
        </template>
        </cb-slide-n-fade>
        <div v-if="total_credits > 0" class="cb-item--extras">
          <div class="cb-item__name">{{ct('credits_applied.label')}}</div>
          <div class="cb-item__deduction">{{ total_credits | cbCurrency(currency_code, true) }}</div>
        </div>
        <!-- Exclusive taxes -->
        <div v-if="consolidated_tax && is_tax_exclusive" class="cb-item--extras">
        <div class="cb-item__name">{{consolidated_tax.title}}</div>
        <div class="cb-item__deduction">{{ consolidated_tax.amount | cbCurrency(currency_code) }}</div>
        </div>
        <div class="cb-item__total">
        {{ (amount_due || 0) | cbCurrency(currency_code) }}
        </div>
        <!-- Inclusive taxes -->
        <div class="cb-item" v-if="consolidated_tax && is_tax_inclusive">
        <div class="cb-item__name">{{cmt('included_tax_group.txt')}} {{consolidated_tax.title}} : {{ consolidated_tax.amount | cbCurrency(currency_code) }}</div>
        </div>
    </div>
    <!-- Metered Billing disclaimer -->
    <div v-if="canShowMeteredBillingDisclaimer" class="cb-fs--sm cb-tc--muted cb-ta--center">
      {{st('metered_billing_cart_disclaimer')}}
    </div>
    <template v-if="canShowCoupon" ref="parent">
        <cb-discount></cb-discount>
    </template>
    <template v-if="canShowRecommendedAddon">
        <cb-recommended-addon></cb-recommended-addon>
    </template>
    <slot></slot>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import LineItem from "@/components/modules/hosted-pages/LineItem"
import Discount from "@/components/modules/hosted-pages/DiscountComponent"
import RecommendedAddon from "@/components/modules/hosted-pages/RecommendedAddonComponent"
import TierHelper from '@/utils/lineitem-tier-helper'
import CartMixin from "@/mixins/cart-mixin"
import ToolTip from "@/components/collections/elements/ToolTip"
import HostedPageHelper from '@/utils/hosted-page-helper'
export default {
  components: {
    'line-item': LineItem,
    'cb-discount': Discount,
    'cb-recommended-addon': RecommendedAddon,
    'tool-tip': ToolTip
  },
  props: ['customClass', 'readonly'],
  mixins: [CartMixin],
  computed: {
    ...mapGetters([
      'order_cart_items',
      'currency_code',
      'discounts',
      'consolidated_discount',
      'consolidated_tax',
      'is_tax_inclusive',
      'is_tax_exclusive',
      'coupon_enabled',
      'multi_coupon_enabled',
      'amount_due',
      'is_discount_present',
      'total_credits'
    ]),
    isMultipleCart() {
      return this.order_cart_items.length > 1  || this.is_discount_present || this.consolidated_tax || this.hasTieredPricing() || (this.total_credits > 0);
    },
    canShowCoupon() {
      return this.coupon_enabled && !this.readonly && (this.multi_coupon_enabled ? true : !this.is_discount_present);
    },
    coupons() {
      /* if atleast 1 manual discount is present, then don't show it into formatted : consolidated_discounts as no classification information via it */
      if (HostedPageHelper.isManualDiscountPresent(this.discounts)) return HostedPageHelper.segregateAndSort(this.discounts);
      return !this.multi_coupon_enabled ? [this.formatter(this.consolidated_discount)] : this.discounts;
    },
    canShowRecommendedAddon() {
      return this.$store.getters.can_allow('change-subscription.action.add_recommended_addons');
    },
    getDiscountTooltipMessage() {
      return this.$store.getters.get_text('hp_v3.discount.tooltip_message') || '';
    },
    canShowMeteredBillingDisclaimer() {
      return !this.order_cart_items.find(item => !item.metered)
    }
  },
  methods: {
    loaded(item) {
      if (item.type == "plan_setup") {
        return !!item.lineItem;
      }
      return !!item.details;
    },
    formatter(discount) {
      return {
        description: discount.title || discount.description,
        amount: discount.amount,
        entity_id: discount.coupon_id || discount.entity_id
      }
    },
    isManualDiscount(item) {
      return HostedPageHelper.isManualDiscount(item);
    }
  }
}
</script>